<template>
    <Card>
        <div class="card-body">
            <router-link :to="{name: 'CreateBankDetailsPage'}">
                <AlphaButton color="teal" class="mr-2">
                    <span>{{ $t('buttons.create') }}</span>
                </AlphaButton>
            </router-link>
        </div>
        <FetchTable :handle="tableHandle" :columns="table.columns" :url="table.url" v-model:orders="table.orders">
            <template #td-name="{row}">
                {{ row.name }}
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
            <template #td-updated_at="{row}">
                {{ DateFormatter.formatDateTime(row.updated_at) }}
            </template>
            <template #td-additional="{row}">
                <router-link :to="{
                    name: 'EditBankDetailsPage',
                    params: {
                        bankDetailUuid: row.uuid
                    }
                }">
                    <Button size="sm" color="light">
                        {{ $t("labels.more_details") }}
                    </Button>
                </router-link>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AlphaButton from '../../../../components/new/button/AlphaButton.vue';
import Button from '../../../../components/new/button/AppButton.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import DateFormatter from '../../../../services/DateFormatter';

export default {
    name: "IndexBankDetails",
    components: {
        Card, AlphaButton, FetchTable, Button
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: '/system/bank-details',
                orders: [],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '200px', type: 'string', order: true},
                    {key: 'name', name: this.$t('table.titles.name'), width: 'auto', type: 'string', order: true},
                    {key: 'code', name: this.$t('table.titles.code'), width: '200px', type: 'string', order: true},
                    {key: 'iban', name: this.$t('table.titles.iban'), width: '200px', type: 'string', order: true},
                    {key: 'bank_name', name: this.$t('table.titles.bank_name'), width: '200px', type: 'string', order: true},
                    {key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'date', order: true},
                    {key: 'updated_at', name: this.$t('table.titles.updated_at'), width: '200px', type: 'date', order: true},
                    {key: "additional", name: '', width: "150px", type: "string", order: false}
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>
